module.exports = __webpack_public_path__ + "img/wakuang.00d21547.png";